import React, { useRef, useEffect } from 'react';
import CheckedCheckboxIcon from 'src/icons/CheckedCheckbox';
import CheckboxIcon from 'src/icons/Checkbox';
import styles from './ZombiePurgeCheckbox.module.scss';

export default function ZombiePurgeCheckbox ({ className, isSelected, onClick, triggerClick }) {
	const inputRef = useRef();

	useEffect( ()=>{
		if( triggerClick ) inputRef.current.click();
	}, [triggerClick]);

	return (	<label 
		className={`relative cursor-pointer mr-2 ${className}`}>
		<input ref={inputRef}
			onClick={onClick && onClick}
			type="checkbox"
			className='absolute left-0 top-0 w-full h-full hidden'/>
		<CheckboxIcon className={styles['zombie-purge-list-checkbox-box']}/>
		{isSelected && <CheckedCheckboxIcon 
			className={`absolute left-0 ${styles['zombie-purge-list-checkbox-box']} ${styles['zombie-purge-list-checkbox-tick']}`}/>}
	</label> );
}






